import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const TemplatesManagement = lazy(() => import('./TemplatesManagement'));
const ViewTemplate = lazy(() => import('./ViewTemplate'));
const TemplateConstructor = lazy(() => import('../templates-constructor/TemplateConstructor'));

const TemplatesManagementConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  authRoles: authRoles.admin,
  routes: [
    {
      path: 'apps/templates-management',
      element: <TemplatesManagement />,
    },
    {
      path: 'apps/templates-management/view/:id',
      element: <ViewTemplate />,
    },
    {
      path: 'apps/templates-management/create',
      element: <TemplateConstructor />,
    },
    {
      path: 'apps/templates-management/edit/:id',
      element: <TemplateConstructor />,
    },
  ],
};

export default TemplatesManagementConfig;
